import { Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';
import { OfferItem } from '../models';
import { AbstractApiResponse } from '../../shared/models';
import { AbstractApiService } from '../../shared/services';
import { UserRoleService } from '../../shared/services/user-role.service';
import { ShippingProvider } from '../../shipping/models';

@Injectable()
export class OfferItemsService {
  constructor(
    private apiService: AbstractApiService,
    private rolesService: UserRoleService
  ) {}

  createOfferItem(payload: OfferItem): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<OfferItem>(
      'ROLE_MWS_OFFER_ITEM_CREATE',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.createObject(`/offer_items`, payload)
    );
  }

  readOfferItem(iri: string): Observable<OfferItem> {
    return this.rolesService.userHasRoleFilter<OfferItem>(
      'ROLE_MWS_OFFER_ITEM_VIEW',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.getObject(iri, true)
    );
  }

  readOfferItems(): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_OFFER_ITEM_LIST',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.getObject(`/offer_items`, true)
    );
  }

  updateOfferItem(iri: string, payload: OfferItem): Observable<OfferItem> {
    return this.rolesService.userHasRoleFilter<AbstractApiResponse>(
      'ROLE_MWS_OFFER_ITEM_EDIT',
      hasRole =>
        hasRole === false
          ? EMPTY
          : this.apiService.updateObject(iri, payload, true)
    );
  }

  deleteOfferItem(iri: string): Observable<AbstractApiResponse> {
    return this.rolesService.userHasRoleFilter<ShippingProvider>(
      'ROLE_MWS_OFFER_ITEM_DELETE',
      hasRole =>
        hasRole === false ? EMPTY : this.apiService.deleteObject(iri, true)
    );
  }
}
